// === FILE: assets/italiansecret-cart-stock-widget.js ===
// Widget avviso stock – versione semplificata, solo event-driven (no polling, no observer)

window.ISStockWidget = (function () {
  if (window.IS_STOCK_GUARD_ENABLED === false) {
    return {
      refresh: function () {},
      scheduleRefresh: function () {},
      show: function () {},
      remove: function () {},
    };
  }
  const WARNING_ID   = "is-stock-warning";
  const WARNING_CLASS = "is-stock-warning";
  const BTN_SELECTOR = 'button[name="checkout"], .cart__submit, .cart__update';

  let debounceTimer = null;

  // --- UI helpers ----------------------------------------------------

  function show(shortages) {
    remove();
    if (!shortages || !shortages.length) return;

    const list = shortages
      .map(s => {
        const name  = (typeof toppingLabel === "function") ? toppingLabel(s.sku) : s.sku;
        const delta = (s.Delta != null) ? s.Delta : (s.needed - s.available);
        return `${name} (${delta} missing)`;
      })
      .join(", ");

    const box = document.createElement("div");
    box.id = WARNING_ID;
    box.className = WARNING_CLASS;
    box.innerHTML = `
      ⚠️ Some ingredients are currently unavailable:<br>
      <strong>${list}</strong><br>
      Please adjust your order or remove an item using these ingredients.
    `;

    const target =
      document.querySelector(".cart__form, form[action='/cart']") ||
      document.querySelector(".cart-section") ||
      document.body;

    target.prepend(box);
  }

  function remove() {
    document.getElementById(WARNING_ID)?.remove();
  }

  function toggleCheckout(disabled) {
    document.querySelectorAll(BTN_SELECTOR).forEach(btn => {
      btn.disabled = !!disabled;
      btn.style.opacity = disabled ? "0.5" : "1";
      btn.style.cursor = disabled ? "not-allowed" : "pointer";

      // 🔒 Previene click JS (tema Local ignora a volte disabled)
      if (disabled) {
        btn.setAttribute("data-blocked", "true");
        btn.addEventListener("click", preventCheckout, true);
      } else {
        btn.removeAttribute("data-blocked");
        btn.removeEventListener("click", preventCheckout, true);
      }
    });
  }

  function preventCheckout(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    alert("Some ingredients are out of stock. Please adjust your order before checkout.");
    return false;
  }

  // --- Blocca anche invio form carrello (submit) ---
  document.addEventListener("DOMContentLoaded", () => {
    const cartForm = document.querySelector("form[action='/cart'], form[action*='/cart']");
    if (cartForm) {
      cartForm.addEventListener("submit", e => {
        const warning = document.getElementById("is-stock-warning");
        if (warning) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert("Some ingredients are out of stock. Please adjust your order before checkout.");
          return false;
        }
      }, true);
    }
  });

  // --- Core: una sola funzione di refresh ----------------------------

  async function refresh() {
    if (typeof validateInventory !== "function") {
      console.warn("🧩 ItalianSecretCartStock – validateInventory non disponibile");
      return;
    }

    const shortages = await validateInventory();

    remove();
    if (shortages.length > 0) {
      show(shortages);
      toggleCheckout(true);
    } else {
      toggleCheckout(false);
    }
  }

  function scheduleRefresh(delay = 300) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      refresh();
    }, delay);
  }

  // --- Event wiring --------------------------------------------------

  function initListeners() {
    // 1) Click su + / – e Remove
    document.body.addEventListener("click", e => {
      if (e.target.closest(".qty-plus, .qty-minus, a.remove")) {
        scheduleRefresh(300);
      }
    });

    // 2) Input manuale nella qty (digitando il numero)
    document.body.addEventListener("input", e => {
      if (e.target.matches(".qty, input[name='updates[]']")) {
        scheduleRefresh(400);
      }
    });

    // 3) Blur (utente esce dal campo quantità)
    document.body.addEventListener("blur", e => {
      if (e.target.matches(".qty, input[name='updates[]']")) {
        scheduleRefresh(100);
      }
    }, true);

    // 4) Evento custom del tema Local: "cart-updated"
    const cartFormEl = document.querySelector("cart-form");
    if (cartFormEl) {
      cartFormEl.addEventListener("cart-updated", () => {
        scheduleRefresh(100);
      });
    } else {
      // fallback, nel caso il tema propaghi su document
      document.addEventListener("cart-updated", () => {
        scheduleRefresh(100);
      });
    }
  }

  // --- Init ----------------------------------------------------------

  document.addEventListener("DOMContentLoaded", () => {
    initListeners();
    // Primo check quando il carrello è pronto
    scheduleRefresh(0);
  });

  return {
    refresh,
    scheduleRefresh,
    show,
    remove,
  };
})();
